import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Button from '@mui/material/Button';
import {useHistory} from "react-router-dom";
import Footer from "../components/Footer";
import TopBarHeader from "../components/TopBarHeader";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    // .MuiTextField-root.css-1u3bzj6-MuiFormControl-root-MuiTextField-root
    root: {
        "& .MuiButton-root": {
            backgroundColor: "#FCB01F",
            "&:hover": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#E3A01B"
            },
            "&:focus": {
                //you want this to be the same as the backgroundColor above
                backgroundColor: "#C98E18",
            }
        }
    }
}));

export default function Page4() {
    const {t, i18n} = useTranslation()
    const classes = useStyles();
    let history = useHistory();

    function handleClick() {
        history.goBack()
    }
    const [elevation, setElevation] = useState(0)
    useEffect(() => {
        window.onscroll = function () {
            if (window.scrollY !== 0) {
                setElevation(3)
            } else {
                setElevation(0)
            }
        };
    }, [window.scrollY])
    return (<>
        <TopBarHeader elevation={elevation} />
        <div className="mainContainer">
            <main className="bodyPage1">
                <div className="image-wrapper">
                    <div className="mainTitlePage1">
                        {t("disclaimer")}
                    </div>
                    <div className="subTitleDisclaimer">
                        {t("disclaimer_date")}
                    </div>
                    <div className="disclaimerTitle">
                        {t("disclaimer_title")}
                    </div>
                    <div className="textDisclaimer">
                        {t("disclaimer_text")}
                    </div>
                </div>
                <div className="image-wrapper" style={{marginBottom: 40, textAlign: 'center', marginTop: 40}}>
                    <div className={classes.root}>
                        <Button disableRipple variant="contained" className="button" onClick={handleClick}>
                            <span className="textButton">{t("disclaimer_back")}</span>
                        </Button>
                    </div>
                </div>
            </main>
            <main className="body2Page1">
                <div className="image-wrapper">
                    <div className="mainTitlePage1">
                        {t("disclaimer")}
                    </div>
                    <div className="subTitleDisclaimer">
                        {t("disclaimer_date")}
                    </div>
                    <div className="disclaimerTitle">
                        {t("disclaimer_title")}
                    </div>
                    <div className="textDisclaimer">
                        {t("disclaimer_text")}
                    </div>
                    <div style={{height: 70}}/>
                    <div className={classes.root}>
                        <Button disableRipple variant="contained" className="button" onClick={handleClick}>
                            <span className="textButton">{t("disclaimer_back")}</span>
                        </Button>
                    </div>
                    <div style={{height: 80}}/>
                </div>
            </main>
        </div>
        <Footer/>
    </>)
}

